import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getProjectList(params) {
  return request({
    url: '/bsProject',
    method: 'get',
    params: params
  })
}

export function getProjectSelectList(params) {
  return request({
    url: '/bsProject/list',
    method: 'get',
    params: params
  })
}

/**
 * 添加
 * @param {*} params
 */
export function addProject(params) {
  return request({
    url: '/bsProject',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 * @param {*} params
 */
export function editProject(params) {
  return request({
    url: '/bsProject',
    method: 'put',
    data: params
  })
}
/**
 * 通过id删除
 */
export function deleteProject(id) {
    return request({
      url: `/bsProject/${id}`,
      method: 'delete',
    })
  }
  /**
   * 查看详情
   */
  export function getProjectInfoById(id) {
    return request({
      url: `/bsProject/${id}`,
      method: 'get'
    })
  }
